import { ensureJobCorn } from '@eigtech/restoration-util'
import { ROUTER_PATHS } from '@/lib/constants'
import { withRequiredPermissions } from '@/lib/permissions'
import { useCohortContext } from '@eigtech/ui-shared-api'
import { format, STANDARD_DATE_TIME_FORMAT } from '@eigtech/ui-shared-dates'
import { Heading, Page } from '@eigtech/ui-shared-dave'
import { UploadMeetingScreenshots } from '@eigtech/ui-shared-meetings'
import { LinkButton } from '@eigtech/ui-shared-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId_/upload'
)({
  component: () => <RoutePage />,
})

function JobDetailMeetingUpload() {
  const { jobId, meetingId, meetingStartTime } = Route.useParams()

  const { cohort } = useCohortContext()

  return (
    <Page
      aboveHeader={
        <LinkButton
          params={{ jobId, meetingStartTime, meetingId }}
          size="sm"
          to={ROUTER_PATHS.jobDetailMeeting.route}
          variant="outline"
        >
          ← Meeting Info
        </LinkButton>
      }
      heading={
        <Heading as="h2" size="md">
          {format(new Date(meetingStartTime), STANDARD_DATE_TIME_FORMAT)}
        </Heading>
      }
    >
      <UploadMeetingScreenshots
        cohort={cohort}
        entityId={ensureJobCorn(jobId)}
        meetingId={meetingId}
      />
    </Page>
  )
}

const RoutePage = withRequiredPermissions(JobDetailMeetingUpload, {
  requiredPermissions: [{ action: 'create', subject: 'meeting' }],
})
